var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocalstall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "29px",
    viewBox: "0 0 32 29",
    enableBackground: "new 0 0 32 29",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#f69516",
    stroke: "#6D4B40",
    cx: 6.397,
    cy: 25.603,
    r: 2.464
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f69516",
    stroke: "#6D4B40",
    d: "M1,13.162V8c0-3.866,3.134-7,7-7h11.945c3.867,0,7,3.134,7,7v5.162H1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D4B40",
    d: "M10.324,1v12.162"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D4B40",
    d: "M18.433,1v12.162"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D4B40",
    d: "M6.271,13.162v6.486"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D4B40",
    d: "M22.486,13.162v6.486"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D4B40",
    d: "M1,22.06v-2.411h25.945v8.108"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D4B40",
    strokeLinecap: "round",
    d: "M1,28.162h30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalstall);
export default __webpack_public_path__ + "static/media/localstall.cdb23cf66ecfd083f9e71e1d4bff2e35.svg";
export { ForwardRef as ReactComponent };